"use client";

import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { useSubscriptionActive } from "../hooks/use-subscription-active";

export const SubscriptionAlertBanner = ({
  contactFormUrl,
}: { contactFormUrl: string }) => {
  const { isActive, isPending } = useSubscriptionActive();

  if (isActive || isPending) return null;

  return (
    <div className="flex items-center justify-start gap-2 rounded bg-red-500 px-4 py-2 text-sm text-white">
      <ExclamationTriangleIcon className="h-6 w-6" />
      <div className="flex-1">
        <span>
          ご利用開始の準備がまだ完了していない可能性があります。
          <br />
          トライアル・ご契約開始前の場合は、初期設定のご案内（初期設定面談）後よりmedimoをご利用いただけます。
          <br />
          本契約中にもかかわらずご利用いただけない場合や、ご不明な点がある場合は、恐れ入りますが、担当者または
          <a
            className="underline"
            href={contactFormUrl}
            target="_blank"
            rel="noreferrer"
          >
            サポート窓口
          </a>
          までお問い合わせください。
        </span>
      </div>
    </div>
  );
};
